module.exports = __webpack_public_path__ + "img/logo.2c514e05.webp";